import React from "react";
import { useParams } from "react-router-dom";
import AddNewPerformanceData from "./AddNewPerformanceData";
import AddPerformBreadCrumb from "./AddPerformBreadCrumb";

function AddPerformanceDataPage() {
  const { cogen_id } = useParams(); // 👈 extract cogen_id from URL

  return (
    <div className="container-fluid">
      <AddPerformBreadCrumb />
      <AddNewPerformanceData cogen_id={cogen_id} /> {/* 👈 pass it down */}
    </div>
  );
}

export default AddPerformanceDataPage;
